/**
 * token操作封装
 */
import { TOKEN_CACHE_NAME } from '@/config/setting';
import { StorageUtil } from './lzd-util';
import { clearTeacherPropCache } from './teacher-prop-cache';

/**
 * 获取缓存的token
 */
export function getToken(): string | null {
  return StorageUtil.get(TOKEN_CACHE_NAME);
}

/**
 * 缓存token
 * @param token token
 * @param remember 是否永久存储
 */
export function setToken(token?: string, _remember?: boolean) {
  // 自动续期只替换 token，保留本次登录加载的教师参数。
  StorageUtil.remove(TOKEN_CACHE_NAME);
  if (token) {
    StorageUtil.set(TOKEN_CACHE_NAME, token);
  }
}

/**
 * 移除token
 */
export function removeToken() {
  StorageUtil.remove(TOKEN_CACHE_NAME);
  clearTeacherPropCache();
}
